import { render } from "./infoBox.vue?vue&type=template&id=366347d2"
import script from "./infoBox.vue?vue&type=script&lang=js"
export * from "./infoBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__